// extracted by mini-css-extract-plugin
export var editButton = "_pv-0";